// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YQYf","left":"styles_left__QC7WS","desktopActions":"styles_desktopActions__HlQM9","title":"styles_title__35LeT"};